import React from 'react';
import { compose, is } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummary.js';
import connect from 'react-redux/es/connect/connect';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import storage from '@synergycms_core/utils/storage';
import { fromJS, List, Map } from 'immutable';
import {
  getPrepaymentText,
  getReservationTotals,
  getReservationTotalsBothModes,
  isRefundable,
  parseServices,
  parseTaxes,
  parseTaxesPreview,
  getRoomName,
  shouldShowTaxes,
  resolveDiscountIdsToShow
} from '../../../utils';
import AvailMainSideSummaryServices from './Render/AvailMainSideSummaryServices';
import AvailMainSideSummaryHotel from './Render/AvailMainSideSummaryHotel';
import { getLoyaltyDiscount } from '../../../store/avail/availUtils';
import { contextualizeAppConfig } from '@synergycms_core/store/app/utils';
import AvailMainSideSummaryRooms from './Render/AvailMainSideSummaryRooms';
import AvailMainSideSummaryHeader from './Render/AvailMainSideSummaryHeader';
import { getSTPoints } from '../../../store/customer/loyaltyUtils';
import AvailMainSideSummaryLoyaltyPoints from './Render/AvailMainSideSummaryLoyaltyPoints';
import AvailMainSideSummaryTaxes from './Render/AvailMainSideSummaryTaxes';
import { getPenalties, getPenaltiesFromAvail, getPenaltyTimezone, getPenaltyChargebackUSA } from '../../../utils/penalties';
import { PROPERTY_MANAGEMENT_GROUP } from '../../../config/constants';
import { isUsDomain } from 'synergycms_core/src/utils/utils.js';
import AvailMainSideSummaryPenalties from './Render/AvailMainSideSummaryPenalties';
import AvailMainSideSummaryReservation from './Render/AvailMainSideSummaryReservation';
import AvailMainSideSummaryHotelInfo from './Render/AvailMainSideSummaryHotelInfo';
import AvailMainSideSummaryLoyaltyDiscount from './Render/AvailMainSideSummaryLoyaltyDiscount';
import AvailMainSideSummaryPromoCodeDiscount from './Render/AvailMainSideSummaryPromoCodeDiscount';
import AvailMainSideSummaryTotalPrice from './Render/AvailMainSideSummaryTotalPrice';
import AvailMainSideSummarySubtotalPrice from './Render/AvailMainSideSummarySubtotalPrice';
import AvailMainSideSummaryEquivalentPrice from './Render/AvailMainSideSummaryEquivalentPrice';
import AvailMainSideSummaryRedeemPoints from './Render/AvailMainSideSummaryRedeemPoints';
import AvailMainSideSummaryGiftCodeDiscount from './Render/AvailMainSideSummaryGiftCodeDiscount';
import AvailMainSideSummaryPay from './Render/AvailMainSideSummaryPay';
import AvailMainSideSummaryDiscount from './Render/AvailMainSideSummaryDiscount';
import { applyMandatoryFeeSplit, summarizeTaxAmounts, buildPayments, getDisplayedTotalPrice, getTaxesInformationText } from './summaryPricing';

const AvailMainSideSummary = class AvailMainSideSummary extends React.Component {
  static displayName = 'AvailMainSideSummary';


  render() {
    const { config, theme, content } = this.props,
      {
        // GENERAL
        reservationConfirmed = false,
        stepCode,
        hotelInfo,
        hotelAvail,
        reservationBlocks,
        showTaxes,
        hotelConfig,
        langActive,
        availHotel,
        forceHotelCurrency,
        reservationObj,
        reservationRequest,
        availServices,
        serviceAvailResponse,
        summaryPriceBreakdown,

        // ROOMS
        totalAdults,
        totalChilds,
        childsInfo,
        staticRooms,
        nights,

        // SERVICES
        parsedServices,
        reservationTotals,
        reservationTotalsBothModes,

        // RATES
        ratesInfo,
        showRateInfo,

        // LOYALTY DISCOUNT
        loyaltyDiscount,
        loyaltyUser,
        loyalty,

        // PROMO CODE DISCOUNT
        promoCodeDiscount,
        promoCode,

        // GIFT CODE DISCOUNT
        giftCode,
        giftCodeDiscount,

        // DISCOUNTS
        discountsInfo,
        showDiscountInfo,

        // REDEEM POINTS
        redeemPoints,

        // TOTAL PRICES
        refundable,
        payformCode,
        paymentPointsDiscount,

        // LOYALTY POINTS
        accumulatePoints,
        showFrontRedeemPoints,

        //PENALTIES
        requiredPrepayment,
        requiredPrepaymentValue,
        requiredPrepaymentType,
        fullFreeReservation,
        currencies,
        langInfo,
        currentCurrencyCode,
        hotelCurrencyCode,
        managementGroupID,

        //altCurrency
        altCurrency
      } = config;
    const { classes } = theme.styles;

    let showAvailPriceAs = hotelConfig.getIn(['show_avail_price_as', langActive,'translatable_value'], "total");

    var totalPriceRooms = reservationTotals.get('rooms_price');
    if(promoCodeDiscount) totalPriceRooms -= promoCodeDiscount;
    if(loyaltyDiscount) totalPriceRooms -= loyaltyDiscount;
    const groupedHotels =  [];

    if(hotelAvail) {
      const hotels = hotelAvail.keySeq().map(key => {
        const block = reservationBlocks.get(key, Map());
        const roomId = block.get('room_id');
        const serviceId = block.get('service_id');
        const boardId = block.get('board_id');
        const roomAvail = hotelAvail && hotelAvail.getIn([key, serviceId ? roomId + '-' + serviceId : roomId]);
        const boardAvail = roomAvail && roomAvail.getIn(['boards', boardId, block.get('unique_ref_type')]);
        const adults = block.get('adults');
        const childs = block.get('childs');
        const babies = block.get('babies');
        const childsInfo = block.get('childs_info');

        // GET ROOM NAME + OCCUPANCY
        const roomSection = roomAvail && (
          staticRooms.find(
            r =>
              r.get('id') === roomAvail.get('room_id') &&
              r.get('occup_group_id') === roomAvail.get('occup_group_id') &&
              r.get('service_id') === roomAvail.get('service_id')
          ) ||
          staticRooms.find(
            r =>
              r.get('id') === roomAvail.get('room_id') &&
              r.get('occup_group_id') === r.get('default_occup_group_id') &&
              r.get('service_id') === roomAvail.get('service_id')
          )
        );
        const needAddOccupName = (roomSection && roomSection.get('occup_group_id') !== roomAvail.get('occup_group_id')) || childsInfo;
        let roomOccupName = getRoomName({ childs, adults, babies, childsInfo });
        let roomName = roomSection && (!childsInfo || childsInfo.size === 0 || (roomAvail && roomAvail.get('service_id')))
            ? roomSection.get('name')
            : roomAvail && roomAvail.get('room_name');

        if (needAddOccupName) roomName += roomOccupName;
      var roomPrice = showTaxes ? block.get('price_tax') : block.get('price');
      const { promoDiscount, loyaltyDiscount, corporateDiscount } = computeDiscountsForBoard(boardAvail, showTaxes);

      if (promoDiscount) roomPrice += promoDiscount;
      if (loyaltyDiscount) roomPrice += loyaltyDiscount;
      if (corporateDiscount) roomPrice += corporateDiscount;


        if (nights <= 1) showAvailPriceAs = 'total';
        const finalLowestPrices = [];
        let currentPriceIndex = 0;
        try {
          if (availHotel) {
            availHotel.forEach(block => {
              const blockRoom =
                block &&
                (
                  block.find(
                    r =>
                      r.get('room_id') === roomAvail.get('room_id') &&
                      r.get('service_id') === roomAvail.get('service_id') &&
                      r.get('board_id') === roomAvail.get('board_id')
                  )
                );

              if (blockRoom) {
                const board = blockRoom.getIn(['boards', boardId]);

                if (board) {
                  const dynamicKey = board.keySeq().first();
                  const days = board.getIn([dynamicKey, 'days']);

                  if (days) {
                    let lowestPrice = Infinity;
                    let lowestPriceTax = Infinity;

                    days.forEach((dayInfo, dayKey) => {
                      var price = dayInfo.get('price');
                      var priceTax = dayInfo.get('price_tax');


                      const discounts = dayInfo.get('discounts', List());
                      if(discounts) {
                        discounts.forEach(discount => {
                          if(discount.get('is_promotion_code') || discount.get('is_corporate') || discount.get('is_loyalty')) {
                            price -= discount.get('amount');
                            priceTax -= discount.get('amount');
                          }
                        });
                      }

                      if (price < lowestPrice) {
                        lowestPrice = price;
                      }

                      if (priceTax < lowestPriceTax) {
                        lowestPriceTax = priceTax;
                      }
                    });

                    const finalPrice = showTaxes ? lowestPriceTax : lowestPrice;


                    finalLowestPrices.push(finalPrice);
                  }
                }
              }
            });
          }
        } catch (error) {
          console.error('Error occurred:', error);
          showAvailPriceAs = 'total';
        }

        let amount;
        let showAvailPriceAsText;



        switch (showAvailPriceAs) {
          case 'noche':
            showAvailPriceAsText = "_%por noche%_";
            if (currentPriceIndex < finalLowestPrices.length) {
              amount = finalLowestPrices[currentPriceIndex];
              currentPriceIndex++;
              // cal descomptar els descomptes de la reserva
            }
            break;
          case 'media':
            showAvailPriceAsText = "_%precio medio%_";
            amount = roomPrice / nights;
            break;
          default:
            showAvailPriceAsText = "";
            amount = roomPrice;
            break;
        }

        // GET RATE INFO (name, description)
        let rateInfo = false;

        if (showRateInfo) {
          const days = boardAvail && boardAvail.get('days');
          const usedRateIds = [];
          if (days) {
            days.forEach(day => {
              const rateId = day.get('rate_id');
              if (rateId && !usedRateIds.includes(rateId)) usedRateIds.push(rateId);
            });
          }
          const usedRatesInfo = ratesInfo.filter(rate => usedRateIds.includes(rate.get('id')));
          if (usedRatesInfo.size === 1) {
            rateInfo = usedRatesInfo.first();
          } else if (usedRatesInfo.size > 1) {
            rateInfo = usedRatesInfo.reduce((acc, value) => {
              const nameVal = acc.get('name', '').trim().length
                ? acc.get('name', '') + ' + ' + value.get('name', '')
                : value.get('name', '');
              return acc.set('name', nameVal);
            }, Map()).set('description', '');
          }
        }

        return {
          boardAvail,
          roomName,
          amount,
          forceHotelCurrency,
          showAvailPriceAsText,
          rateInfo
        }
      })

      hotels.forEach(hotel => {
        const index = groupedHotels.findIndex(groupedHotel => groupedHotel.roomName === hotel.roomName && groupedHotel.boardAvail.get('board_name') === hotel.boardAvail.get('board_name'));
        if (index === -1) {
          groupedHotels.push({
            roomName: hotel.roomName,
            boardAvail: hotel.boardAvail,
            boardName: hotel.boardAvail.get('board_name'),
            amount: hotel.amount,
            showAvailPriceAsText: hotel.showAvailPriceAsText,
            quantity: 1,
            rateInfo: hotel.rateInfo
          });
        } else {
          groupedHotels[index].quantity += 1;
          if(showAvailPriceAs !== 'noche') groupedHotels[index].amount += hotel.amount;
        }
      })
    } else {
      return  <></>
    }


    /********** DISCOUNTS **********/
    let discountInfo = null;

    if (showDiscountInfo) {
      const usedDiscounts = fromJS(
        reservationRequest
          .get('blocks', List())
          .toJS()
          .reduce((acc, block) => acc.concat(block.discounts || []), [])
      ).map(d => {
        const info = discountsInfo.find(di => di.get('id') === d.get('id'));
        return info ? d.set('overlapping', info.get('overlapping')) : d;
      });

      const usedDiscountIds = usedDiscounts.map(d => d.get('id')).toSet();
      const usedDiscountsInfo = discountsInfo.filter(d => usedDiscountIds.includes(d.get('id')));
      const discountIdsToShow = resolveDiscountIdsToShow(usedDiscounts);

      const discounts = usedDiscountsInfo
        .filter(d => discountIdsToShow.includes(d.get('id')))
        .map(d => {
          const totalAmount = usedDiscounts
            .filter(used => used.get('id') === d.get('id'))
            .reduce((sum, used) => sum + used.get('amount', 0), 0);
          return d.set('total_amount', totalAmount);
        });

      if (discounts.size > 0) discountInfo = discounts;
    }

    /********** TAXES **********/
    const summaryBreakdownMode = hotelConfig.get('summary_taxes_breakdown', 'default');
    const parsedTaxes = reservationObj && stepCode !== 'serviceHotelAvail'
      ? parseTaxes(hotelInfo, reservationObj, summaryBreakdownMode)
      : parseTaxesPreview(
        hotelInfo,
        hotelAvail,
        serviceAvailResponse.get('services', false),
        reservationRequest,
        summaryBreakdownMode
    );

    // GLOSARIO.md FCL-003
    const { taxes, additionalFees } = applyMandatoryFeeSplit(parsedTaxes, summaryPriceBreakdown);

    /*********** PENALTIES **********/

    let penalties = null;

    let requiredPrepaymentCalc = 0;
    let requiredPrepaymentText = '';
    if (requiredPrepayment > 0 && !fullFreeReservation && refundable && currencies) {
      requiredPrepaymentCalc = requiredPrepayment;
      requiredPrepaymentText = getPrepaymentText(
        requiredPrepayment,
        requiredPrepaymentValue,
        requiredPrepaymentType,
        currencies,
        currentCurrencyCode,
        hotelCurrencyCode,
        langInfo,
        content,
        forceHotelCurrency
      );
    }
    const rateSecureCancellation = reservationObj && reservationObj?.get('rates')?.some(d => d?.get('secure_cancellation', false));
    const discountSecureCancellation = reservationObj && reservationObj?.get('discounts')?.some(d => d?.get('secure_cancellation', false));
    const serviceSecureCancellation = reservationObj && reservationObj?.get('services')?.some(d => d?.get('secure_cancellation', false));
    const pmsName = hotelInfo && hotelInfo.get('pms');
    const pms = ((rateSecureCancellation || discountSecureCancellation || serviceSecureCancellation) && pmsName === 'FlexMyRoom') ? 'FlexMyRoom' : false;

    if (reservationObj && stepCode !== 'serviceHotelAvail') {
      penalties = getPenalties(reservationObj, managementGroupID === PROPERTY_MANAGEMENT_GROUP, pms, null, managementGroupID, getPenaltyTimezone(hotelInfo), getPenaltyChargebackUSA(hotelInfo));
    } else if (stepCode === 'serviceHotelAvail' && hotelAvail) {
      penalties = getPenaltiesFromAvail(
        hotelAvail,
        reservationBlocks,
        reservationRequest.get('checkin'),
        reservationRequest.get('checkout'),
        managementGroupID === PROPERTY_MANAGEMENT_GROUP,
        pms,
        null,
        managementGroupID,
        reservationTotals,
        availServices.get('services', List()),
        getPenaltyTimezone(hotelInfo),
        getPenaltyChargebackUSA(hotelInfo)
      );
    }

    const discountPercent = reservationTotals ? reservationTotals.get('discount_percent') : 0;

    const removeGap = !!((redeemPoints || giftCodeDiscount) && hotelCurrencyCode && currentCurrencyCode && hotelCurrencyCode === currentCurrencyCode);

    const showBoxTaxes = taxes.nonIncluded.length > 0 || !!hotelInfo.get('city_tax');
    const showBoxPenalties = !!penalties;
    const showBoxHotelInfo = hotelInfo.get('country_iso_code') === 'US' && managementGroupID === PROPERTY_MANAGEMENT_GROUP;
    const nothingBelow = !showBoxTaxes && !showBoxPenalties && !showBoxHotelInfo;
    /********** TOTAL PRICE **********/
    const totalPrice = reservationTotals.get('total_price');
    const totalPriceWithTaxes = reservationTotalsBothModes.getIn(['with_taxes','total_price']);
    let totalPriceWithoutTaxes = reservationTotalsBothModes.getIn(['without_taxes','total_price']);

    // GLOSARIO.md FCL-003 - la fee obligatoria cuenta como parte del total "sin impuestos"
    totalPriceWithoutTaxes += additionalFees;

    const bookingDate = reservationObj && reservationObj.get('booking_date')
    const checkin = reservationObj && reservationObj.get('checkin');
    const daysDifference = reservationObj && Math.ceil((new Date(checkin) - new Date(bookingDate)) / (1000 * 60 * 60 * 24));
    const release = (penalties && penalties[0] && penalties[0].release) || 0;
    const isHotelPayment =
      (refundable && !['op', 'paypal', 'amazon_pay'].includes(payformCode)) ||
      (hotelInfo.get('chargeback_usa', false) && !refundable && daysDifference !== false && release >= daysDifference)

    const { rateTaxes, nonRateTaxes, nonIncludedTaxes } = summarizeTaxAmounts(taxes);

    const payments = buildPayments({
      summaryPriceBreakdown,
      payformCode,
      totalPrice,
      totalPriceWithoutTaxes,
      rateTaxes,
      nonRateTaxes,
      nonIncludedTaxes,
      giftCodeDiscount,
      paymentPointsDiscount,
      requiredPrepaymentCalc,
      isHotelPayment,
      redeemPoints,
    });

    const taxesInformationText = getTaxesInformationText(managementGroupID);

    const displayedTotalPrice = getDisplayedTotalPrice({ summaryPriceBreakdown, nonIncludedTaxes, priceBase: totalPriceWithoutTaxes, totalPriceWithTaxes, totalPrice });

    return (
      <div className={theme.computedInnerStyle}>

        <div className={classes.availMainSideSummaryHeader}>
          <AvailMainSideSummaryHeader reservationConfirmed={reservationConfirmed} />
        </div>

        <div className={classes.separator}></div>

        <div className={classes.content}>

          <div className={classes.availMainSideSummaryHotel}>
            <AvailMainSideSummaryHotel totalAdults={totalAdults} totalChilds={totalChilds}/>
          </div>

          <div className={classes.separator}></div>

          <div className={classes.availMainSideSummaryReservation}>
            <AvailMainSideSummaryReservation totalAdults={totalAdults} totalChilds={totalChilds} childsInfo={childsInfo}/>
          </div>

          <div className={classes.separator}></div>

          <div className={classes.summaryBookingBox}>
            <AvailMainSideSummaryRooms totalPriceRooms={totalPriceRooms} groupedRooms={groupedHotels} />

            {Object.keys(parsedServices).length !== 0 && (
              <AvailMainSideSummaryServices parsedServices={parsedServices} totalPriceServices={reservationTotals?.get('services_price')} />
            )}

            {!!discountInfo && (
              <AvailMainSideSummaryDiscount discountInfo={discountInfo} />
            )}

            {!!loyaltyDiscount && (
              <AvailMainSideSummaryLoyaltyDiscount loyaltyDiscount={loyaltyDiscount} loyaltyUser={loyaltyUser} loyalty={loyalty}/>
            )}

            {!!promoCodeDiscount && (
              <AvailMainSideSummaryPromoCodeDiscount promoCodeDiscount={promoCodeDiscount} promoCode={promoCode} />
            )}

            {taxes.included.length > 0 && (
              <AvailMainSideSummaryTaxes
              taxes={taxes.included}
              summaryBreakdownMode={summaryBreakdownMode}
              included={true}
              summaryPriceBreakdown={summaryPriceBreakdown}/>
            )}
          </div>

          <div className={classes.separator}></div>

          {summaryPriceBreakdown && (
            <>
              <div className={[classes.availPaymentBox, payments.length === 1 && !giftCodeDiscount ? classes.removeGap : ''].join(' ')}>
                <AvailMainSideSummarySubtotalPrice
                  totalPrice={showTaxes ? totalPriceWithTaxes : totalPriceWithoutTaxes}
                  text={'_%subtotal%_'}
                  taxes={taxes.nonIncluded}
                  included={false}
                />
              </div>
              <div className={classes.separator}></div>
            </>
          )}

          <div className={[classes.availPaymentBox, payments.length === 1 && !giftCodeDiscount ? classes.removeGap : ''].join(' ')}>
            <AvailMainSideSummaryTotalPrice
              totalPrice={displayedTotalPrice}
              text={summaryPriceBreakdown || showTaxes ? '_%importe total%_' : '_%importe subtotal%_'}
              payments={payments}
            />

            {((stepCode !== 'confirmation' && (!!redeemPoints || !!giftCodeDiscount)) || altCurrency ) && !summaryPriceBreakdown && (
              <AvailMainSideSummaryEquivalentPrice
                totalPrice={totalPrice}
                removeGap={removeGap}
                altCurrency={altCurrency}/>
            )}

            {!!redeemPoints && (
              <AvailMainSideSummaryRedeemPoints redeemPoints={redeemPoints}/>
            )}

            {!!giftCodeDiscount && (
              <AvailMainSideSummaryGiftCodeDiscount giftCode={giftCode} giftCodeDiscount={giftCodeDiscount}/>
            )}

            {payments && payments.map((pay,key) => (
              <div key={key}>
                <AvailMainSideSummaryPay
                  redeemPoints={redeemPoints}
                  stepCode={stepCode}
                  text={pay.text}
                  value={pay.amount}
                  isEquivalent={pay.isEquivalent}
                  showRight={payments.length === 1}
                  giftCodeDiscount={giftCodeDiscount}
                  summaryPriceBreakdown={summaryPriceBreakdown}
                />
              </div>
            ))}
          </div>

          {!!accumulatePoints && !showFrontRedeemPoints && (
            <>
              <div className={classes.separator}></div>

              <div className={[classes.availMainSideSummaryLoyaltyPoints, nothingBelow ? classes.removePaddingBottom : ''].join(' ')}>
                <AvailMainSideSummaryLoyaltyPoints accumulatePoints={accumulatePoints} loyalty={loyalty} />
              </div>
            </>
          )}

          {(taxes.nonIncluded.length > 0 || !!hotelInfo.get('city_tax')) && !(summaryPriceBreakdown && !hotelInfo.get('city_tax')) &&
            <>
              <div className={classes.separator}></div>
              <div className={[classes.availMainSideSummaryTaxes, !penalties ? classes.removePaddingBottom : ''].join(' ')}>
                <AvailMainSideSummaryTaxes
                  taxes={taxes.nonIncluded}
                  included={false}
                  title={((['customerForm', 'confirmation'].includes(stepCode) && taxes.nonIncluded.length > 0) || !!hotelInfo.get('city_tax')) ? taxesInformationText : null}
                  cityTax={hotelInfo.get('city_tax')}
                  summaryPriceBreakdown={summaryPriceBreakdown}
                />
              </div>
            </>
          }

          {penalties &&
            <AvailMainSideSummaryPenalties penalties={penalties} pms={pms} discountPercent={discountPercent} text={requiredPrepaymentText} stepCode={stepCode} />
          }

          {managementGroupID === PROPERTY_MANAGEMENT_GROUP && (
            <div className={classes.availMainSideSummaryHotelInfo}>
              <AvailMainSideSummaryHotelInfo/>
            </div>
          )}

        </div>
      </div>
    );
  }
};


const getDiscountValue = (amount, showTaxes, taxPercent) => {
    const base = Math.abs(amount);
    return showTaxes ? base : base / (taxPercent / 100 + 1);
  };

const computeDiscountsForBoard = (boardAvail, showTaxes) => {
  const days = boardAvail?.get('days');
  if (!days) return { promoDiscount: 0, loyaltyDiscount: 0, corporateDiscount: 0 };

  return days.reduce((acc, day) => {
    const taxPercent = day.get('tax_percent', 0);
    const taxesIncluded = day.get('taxes_included', false);

    const getDiscountValue = (amount) => {
      const base = Math.abs(amount);
      const taxMultiplier = taxPercent / 100 + 1;

      if (taxesIncluded) {
        return showTaxes ? base : base / taxMultiplier;
      }
      return showTaxes ? base * taxMultiplier : base;
    };

    return day.get('discounts', List()).reduce((innerAcc, d) => {
      const amount = d.get('amount', 0);
      if (d.get('is_promotion_code'))
        return { ...innerAcc, promoDiscount: innerAcc.promoDiscount + getDiscountValue(amount) };
      if (d.get('is_loyalty'))
        return { ...innerAcc, loyaltyDiscount: innerAcc.loyaltyDiscount + getDiscountValue(amount) };
      if (d.get('is_corporate'))
        return { ...innerAcc, corporateDiscount: innerAcc.corporateDiscount + getDiscountValue(amount) };
      return innerAcc; // descuentos sin ninguno de estos 3 flags (ej. HolaT): se quedan embebidos
    }, acc);
  }, { promoDiscount: 0, loyaltyDiscount: 0, corporateDiscount: 0 });
};

const computeDiscountsForBlock = (block, showTaxes) => {
  const discounts = block.get('discounts');
  if (!discounts?.find) return { promoDiscount: 0, loyaltyDiscount: 0, corporateDiscount: 0 };

  const taxPercent = (block.get('price_tax') / block.get('price') - 1) * 100;

  const getDiscountValue = (amount) => {
    const base = Math.abs(amount);
    return showTaxes ? base : base / (taxPercent / 100 + 1);
  };

  return discounts.reduce((acc, d) => {
    const amount = d.get ? d.get('amount', 0) : d.amount;

    if (d.get ? d.get('is_promotion_code') : d.is_promotion_code)
      return { ...acc, promoDiscount: acc.promoDiscount + getDiscountValue(amount) };
    if (d.get ? d.get('is_loyalty') : d.is_loyalty)
      return { ...acc, loyaltyDiscount: acc.loyaltyDiscount + getDiscountValue(amount) };
    if (d.get ? d.get('is_corporate') : d.is_corporate)
      return { ...acc, corporateDiscount: acc.corporateDiscount + getDiscountValue(amount) };

    return acc;
  }, { promoDiscount: 0, loyaltyDiscount: 0, corporateDiscount: 0 });
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps, content) => {
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code']);
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const hotel = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const queryParams = store.getIn(['hotels', hotelId, 'params', 'params']);
  const reservationObj = store.getIn(['customer', 'reservation'], false);
  const reservationRequest = store.getIn(['customer', 'reservation_request'], false);
  const availServices = store.getIn(['availServices',hotelId, store.getIn(['hotels', hotelId, 'params', 'service_query_params']),'response'], false);
  const showTaxes = stepCode === 'serviceHotelAvail' ? hotelInfo.get('show_taxes') : shouldShowTaxes(hotel, reservationObj) ?? true;
  const forceTaxes = !hotelInfo.get('show_taxes') && showTaxes ? true : null;
  const hotelConfig = contextualizeAppConfig(store, hotelId);

  /******* hotelAvail *******/
  const freshHotelAvail = store.getIn(['avail', hotelId, store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono", "query_params"])]), 'response']);

  const hotelAvail =
      stepCode === 'confirmation'
        ? (freshHotelAvail && freshHotelAvail.size > 0 ? freshHotelAvail : (storage.get('hotel_avail') ? fromJS(storage.get('hotel_avail')) : freshHotelAvail))
        : freshHotelAvail;

  if (hotelAvail && stepCode !== 'confirmation') {
      storage.set('hotel_avail', hotelAvail.toJS());
  }
  /******* totalAdults | totalChilds *******/
  const reservationBlocks = store.getIn(['customer', 'reservation_request', 'blocks']);
  let totalAdults = 0;
  let totalChilds = 0;
  let childsInfo = List();
  if (reservationBlocks) {
    reservationBlocks.forEach(block => {
      const roomAvail = hotelAvail && hotelAvail.getIn([block.get('idx') - 1, block.get('room_id')]);
      totalAdults += roomAvail && roomAvail.get('adults', 0);
      totalChilds += roomAvail && roomAvail.get('childs', 0) + roomAvail.get('babies', 0);
      if(roomAvail && roomAvail.get('childs_info')?.size){
        childsInfo = childsInfo.merge(roomAvail.get('childs_info'));
      }
    });
  }


  /******* serviceAvailResponse *******/
  const serviceAvailResponse =
    stepCode === 'confirmation' && storage.get('service_avail') ? fromJS(storage.get('service_avail')) : store.getIn([
      'availServices',
      hotelId,
      store.getIn(['hotels', hotelId, 'params', 'service_query_params']),
      'response'
    ]);
  if (serviceAvailResponse && stepCode !== 'confirmation') {
    storage.set('service_avail', serviceAvailResponse.toJS());
  }


  /******* SERVICES *******/
  const services = parseServices(hotelInfo, reservationBlocks, hotelAvail, serviceAvailResponse);
  let parsedServices = [];
  services && services.forEach(service => {
    const serviceInfo = serviceAvailResponse.get('services').find(availService => availService.get('id') === service.get('service_id'));
    const key = (service.get('service_id') + '-' + (service.get('stringDate') ? service.get('stringDate') : '')).replace(/\s+/g, '');

    parsedServices[key] = {
      serviceId: service.get('service_id'),
      serviceName: serviceInfo.get('name'),
      servicePrice: service.get('price'),
      quantity: service.get('quantity'),
      stringDate: service.get('stringDate') || '',
    };
  });


  /******* PROMO CODE DISCOUNT *******/

  let promoCodeDiscount = null;
  let promoCode;

  promoCode = (queryParams && queryParams.get('promotion_code')) || queryParams.get('avail_code');

  if (queryParams && promoCode && hotelAvail && reservationBlocks) {
    promoCodeDiscount = reservationBlocks.reduce((value, block, idx) => {
      const selectedRateAvail = hotelAvail.getIn([
        idx,
        block.get('room_id'),
        'boards',
        block.get('board_id'),
        block.get('unique_ref_type')
      ]);

      const computedDiscountValue =
        selectedRateAvail &&
        selectedRateAvail.get('days').reduce((total, day) => {
          const findDiscount = day.get('discounts', List()).find(discount => {
            return discount.get('is_promotion_code');
          });
          let discountValue = 0;

          if (findDiscount) {
            const baseDiscountValue = Math.abs(findDiscount.get('amount', 0));
            if (!day.get('taxes_included') && hotel.get('show_taxes')) {
              discountValue = baseDiscountValue + (baseDiscountValue * day.get('tax_percent')) / 100;
            } else if (day.get('taxes_included') && !hotel.get('show_taxes')) {
              discountValue = baseDiscountValue / (day.get('tax_percent') / 100 + 1);
            } else {
              discountValue = findDiscount.get('amount', 0);
            }
          }

          return total + (discountValue || 0);
        }, 0);
      return value + computedDiscountValue;
    }, 0);
    if (promoCodeDiscount > 0) {
      promoCodeDiscount *= -1;
    }
  }

  const currencies = store.getIn(['customer', 'currencies']);
  let tpvConfig = !(hotel.getIn(['tpv_only_gift_voucher'], false)) ? hotel.getIn(['tpv', 'name'], false) : false;
  let tpvParams = hotel.getIn(['tpv', 'tpv_params'], false);
  let currencyConfig = tpvConfig === 'EPG' && tpvParams.find(p => p.get('code') === 'currency_code')?.get('value','');
  let altCurrency = (currencyConfig && currencyConfig !== '') ? currencyConfig : false;
  if(altCurrency) {
    let existsCurrency = currencies.find(c => c.get('code') === altCurrency) || false;
    if(!existsCurrency) {
      altCurrency = false;
    }
  }
  /********** GIFT CODE DISCOUNT **********/

  const amountPromoPaid = reservationObj.getIn(['payment', 'amount_promo_paid'], 0);
  let giftCode = null;
  let giftCodeDiscount = 0;

  var showFrontRedeemPoints = false;

  if(reservationObj &&
    reservationObj.getIn(["customer", "guest_booker"]) &&
    reservationObj.getIn(["customer", "guest_booker"]).size &&
    reservationObj.getIn(["customer", "guest_booker"]).size > 0) {
    showFrontRedeemPoints = true;
  }

  const redeemPoints  = reservationObj.getIn(["loyalty", "redeem_points"], 0);

  if (amountPromoPaid > 0 && reservationObj.getIn(['gift_voucher', 'code'], '') !== '') {
    giftCodeDiscount = amountPromoPaid * -1;
    giftCode = reservationObj.getIn(['gift_voucher', 'code']);
  }

  const refundable = isRefundable(
    hotelAvail,
    reservationBlocks,
    parseServices(hotelInfo, reservationBlocks, hotelAvail, serviceAvailResponse),
    serviceAvailResponse,
    hotel.get('management_group_id'),
    stepCode === 'confirmation'
  )


  /******* PENALTIES *******/
  let requiredPrepayment = 0;
  let requiredPrepaymentType = false;
  let requiredPrepaymentValue = false;

  if (reservationBlocks) {
    reservationBlocks.forEach(block => {
      requiredPrepayment += block.get('required_prepayment', 0);
      if (!requiredPrepaymentType) {
        requiredPrepaymentType = block.get('required_prepayment_type', '');
        requiredPrepaymentValue = block.get('required_prepayment_value', 0);
      }
    });
  }

  if (reservationObj) {
    requiredPrepayment = 0;
    requiredPrepaymentType = false;
    requiredPrepaymentValue = false;
    reservationObj.get('blocks', List()).forEach(block => {
      requiredPrepayment += block.get('required_prepayment', 0);
      if (!requiredPrepaymentType) {
        requiredPrepaymentType = block.get('required_prepayment_type', '');
        requiredPrepaymentValue = block.get('required_prepayment_value', 0);
      }
    });
  }

  let fullFreeReservation = false;
  const firstPenalty = reservationObj && reservationObj.getIn(['penalties', 0]);
  if (firstPenalty) {
    fullFreeReservation = (firstPenalty.get('release', null) === 23976 && firstPenalty.get('type', null) === 'percentage'
      && firstPenalty.get('value', null) === 0 && firstPenalty.get('show_as', null) === 'days');
  }

  return {
    // GENERAL
    stepCode,
    hotelId: hotelId,
    hotelInfo: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo,
    hotelAvail: is(List, hotelAvail) && hotelAvail.size > 0 && hotelAvail,
    reservationBlocks,
    showTaxes,
    hotelConfig: hotelConfig,
    langActive: store.getIn(['customer', 'lang_info','code']),
    availHotel: store.getIn(['avail', hotelId, store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono", "query_params"])]), 'response'], null),
    forceHotelCurrency: stepCode === 'confirmation',
    reservationObj: reservationObj.size ? reservationObj : false,
    reservationRequest: reservationRequest.size ? reservationRequest : false,
    availServices: availServices.size ? availServices : false,
    summaryPriceBreakdown: hotel && hotel.get('summary_price_breakdown', false),

    // ROOMS
    totalAdults,
    totalChilds,
    childsInfo,
    staticRooms: store.getIn(['hotels', hotelId, 'rooms'], List()),
    nights: queryParams.get('stay_length', 1),

    // SERVICES
    serviceAvailResponse,
    parsedServices,
    reservationTotals: reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotals(store, forceTaxes),
    reservationTotalsBothModes: reservationBlocks && is(List, reservationBlocks) && reservationBlocks.size > 0 && getReservationTotalsBothModes(store),

    // RATES
    ratesInfo: hotelInfo.get('rates', List()),
    showRateInfo: hotelConfig.get('show_rate_info', false),

    // LOYALTY DISCOUNT
    loyaltyDiscount: getLoyaltyDiscount(store),
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
    loyalty: store.getIn(['customer', 'loyalty', 'data','loyalty'], null),

    // PROMO CODE DISCOUNT
    promoCodeDiscount: promoCodeDiscount,
    promoCode: promoCode,

    // GIFT CODE DISCOUNT
    giftCode,
    giftCodeDiscount,

    // DISCOUNTS
    discountsInfo: hotelInfo.get('discounts', List()),
    showDiscountInfo: hotelConfig.get('show_discount_info', false),

    // REDEEM POINTS
    redeemPoints,

    // TOTAL PRICES
    refundable,
    payformCode: reservationObj.getIn(['payment', 'payform_code'], 0),
    paymentPointsDiscount: reservationObj.getIn(["loyalty", "total_points_price"], 0)*-1,

    // LOYALTY POINTS
    accumulatePoints: getSTPoints(store,showFrontRedeemPoints),
    showFrontRedeemPoints,

    //PENALTIES
    requiredPrepayment,
    requiredPrepaymentValue,
    requiredPrepaymentType,
    fullFreeReservation,
    currencies: store.getIn(['customer', 'currencies']),
    langInfo: store.getIn(['customer', 'lang_info']),
    currentCurrencyCode: store.getIn(['customer', 'current_currency']) || undefined,
    hotelCurrencyCode: store.getIn(['hotels', hotelId, 'currency', 'code']),
    managementGroupID: is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo.get('management_group_id'),
    altCurrency: altCurrency,
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps, ['reservationConfirmed']),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'stepCode',
    'reservationConfirmed',
    'hotelId',
    'hotelInfo',
    'hotelAvail',
    'reservationBlocks',
    'showTaxes',
    'hotelConfig',
    'langActive',
    'availHotel',
    'forceHotelCurrency',
    'reservationObj',
    'reservationRequest',
    'availServices',
    'summaryPriceBreakdown',

    // ROOMS
    'totalAdults',
    'totalChilds',
    'childsInfo',
    'staticRooms',
    'nights',

    // SERVICES
    'serviceAvailResponse',
    'parsedServices',
    'reservationTotals',
    'reservationTotalsBothModes',

    // RATES
    'ratesInfo',
    'showRateInfo',

    // LOYALTY DISCOUNT
    'loyaltyDiscount',
    'loyaltyUser',
    'loyalty',

    // PROMO CODE DISCOUNT
    'promoCodeDiscount',
    'promoCode',

    // GIFT CODE DISCOUNT
    'giftCode',
    'giftCodeDiscount',

    // DISCOUNTS
    'discountsInfo',
    'showDiscountInfo',

    // REDEEM POINTS
    'redeemPoints',

    // TOTAL PRICES
    'refundable',
    'payformCode',
    'paymentPointsDiscount',

    // LOYALTY POINTS
    'accumulatePoints',
    'showFrontRedeemPoints',

    //PENALTIES
    'requiredPrepayment',
    'requiredPrepaymentValue',
    'requiredPrepaymentType',
    'fullFreeReservation',
    'currencies',
    'langInfo',
    'currentCurrencyCode',
    'hotelCurrencyCode',
    'managementGroupID',
    'altCurrency'
]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummary);
